import {Box} from '@mui/material';
import React from 'react';
import {LABEL_STYLES} from '../config.js';
import CompareButton from './compare-button.jsx';
import LabelsButton from './labels-button.jsx';
import ZoomButtons from './zoom-buttons.jsx';
import ZoomToMosaic from './zoom-to-mosaic.jsx';

const MapTools = () => (
  <Box
    data-qe="maptools"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      right: theme => theme.spacing(2),
      bottom: theme => theme.spacing(3.5),
    }}
  >
    <CompareButton />

    <ZoomToMosaic />

    {LABEL_STYLES && <LabelsButton />}

    <ZoomButtons />
  </Box>
);

export default MapTools;
